import { pushers } from '@/mocks/pushers';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function PusherMap() {
  return (
    <section id="pushers" className="w-full bg-foreground-950">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          kicker="Backstage Files"
          title="幕后推手图谱 · 代号背后的固定协作"
          description="他们很少出现在署名里，却在多个热点事件中反复同框。我们用代号记录分工，而不是制造新的谜团。"
          linkHref="#voices"
          linkLabel="看看读者怎么说"
          tone="dark"
        />

        <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-50/10 bg-background-50/10 md:grid-cols-2 lg:grid-cols-3">
          {pushers.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col bg-foreground-950 p-6 transition-colors hover:bg-foreground-900 md:p-7"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-primary-300">
                  <i className="ri-spy-line text-xl" />
                </span>
                <span className="rounded-full border border-accent-400/30 px-3 py-1 text-[11px] text-accent-300">
                  {item.role}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-background-50">{item.code}</h3>
              <p className="mt-2.5 flex-1 text-sm leading-relaxed text-foreground-300">{item.methods}</p>
              <div className="mt-5 flex flex-wrap gap-2 border-t border-background-50/10 pt-4">
                {item.links.map((link) => (
                  <span key={link} className="flex items-center gap-1.5 text-[11px] text-foreground-400">
                    <i className="ri-links-line text-accent-400" />
                    {link}
                  </span>
                ))}
              </div>
            </article>
          ))}
          <article className="flex flex-col justify-center gap-4 bg-foreground-900 p-6 md:p-7">
            <p className="font-heading text-lg font-bold leading-snug text-background-50">
              你手里也有没被写出来的那部分吗？
            </p>
            <p className="text-sm leading-relaxed text-foreground-300">
              匿名的材料、截图与时间线同样重要。我们会先核验，再决定用什么方式呈现。
            </p>
            <a
              href="#subscribe"
              className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line text-base" />
              提交一条线索
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}